import NewlyEnrolledTable from 'components/organisms/ccm-console/newly-enrolled-table';
import PartialsTable from 'components/organisms/ccm-console/partials-table';
import FollowUpTable from 'components/organisms/ccm-console/follow-up-table';
import WorkingQueue from 'components/organisms/ccm-console/working-queue';
import { type FC } from 'react';
import { KeyNotesDrawer } from 'components/organisms/oneplaform/key-notes-drawer';
import ScrollToTopButton from 'components/atoms/scroll-to-top-button';
import DashboardLayout from 'components/templates/dashboard-layout';
import { useCCMDataQueryFilter } from 'infrastructure/hooks/ccm/console/use-ccm-data-query-filter';
import { useDrawer } from 'components/organisms/ccm-console/notes-drawer/hooks/use-drawer';

import s from './styles.module.scss';

interface CCMConsolePageProps {}

const CCMConsolePage: FC<CCMConsolePageProps> = () => {
  const { filter, updateFilter } = useCCMDataQueryFilter();
  const {
    handleCloseDrawer,
    isOpenDrawer,
    patientGuid,
    patientInfo,
    handleNoteSaved,
  } = useDrawer();
  return (
    <DashboardLayout
      showCcmHeaderActions
      ccmFilter={filter}
      updateCcmFilter={updateFilter}
    >
      <div className={s.wrapper}>
        <WorkingQueue />
        <NewlyEnrolledTable />
        <PartialsTable />
        <FollowUpTable />
        <KeyNotesDrawer
          isRPM={false}
          open={isOpenDrawer}
          onClose={handleCloseDrawer}
          patientGuid={patientGuid}
          patientInfo={patientInfo}
          onNoteSaved={handleNoteSaved}
        />
        <ScrollToTopButton />
      </div>
    </DashboardLayout>
  );
};

export default CCMConsolePage;
